<template>
  <el-dialog :visible.sync="visible" width="1400px" @close="handleCancel" :title="title">
    <div class="add-plan">
      <div class="add-plan__form">
        <el-form :model="planForm" ref="planForm" label-position="left" label-width="100px" :rules="rules">
          <el-row>
            <el-col :span="8">
              <el-form-item label="计划名称" prop="planName">
                <el-input v-model="planForm.planName" style="width: 300px" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="频率" prop="rate">
                <el-select placeholder="全部" v-model="planForm.rate" style="width: 300px">
                  <el-option v-for="item in rateList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执行人员" prop="peopleName">
                <el-input v-model="planForm.peopleName" style="width: 300px" readonly>
                  <i slot="suffix" class="el-input__icon el-icon-more" style="cursor: pointer" @click="chosePeople"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划日期" v-if="planForm.rate == '1'" prop="dates">
                <el-date-picker v-model="planForm.dates" type="dates" placeholder="选择日期" style="width: 300px"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="计划日期" v-else prop="dates">
                <el-date-picker v-model="planForm.dates" type="daterange" style="width: 300px" value-format="yyyy-MM-dd"
                  start-placeholder="起始日期" end-placeholder="截止日期" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开始时间" prop="times">
                <el-time-picker style="width: 300px" v-model="planForm.times" value-format="HH:mm:ss" placeholder="选择时间"
                  :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }">
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="持续时长" prop="duration">
                <el-input v-model="planForm.duration" style="width: 270px"></el-input>
                <span>分钟</span>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="planForm.remark" type="textarea" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="add-plan__info">
        <div class="info-content">
          <div class="info-content__opt">
            <el-button type="primary" @click="handleAddDevice">添加设备</el-button>
            <el-button @click="handleBatchDelete">批量删除</el-button>
            <el-button @click="setStandardMutil">批量设置标准</el-button>
            <el-button @click="resetStandard">重置标准</el-button>
          </div>
          <el-table :columns="tableColumns" :data="tableData" @selection-change="changeSelection" height="100%">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="deviceName" label="巡检设备" align="center"></el-table-column>
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <span>{{ dealdeviceType(scope.row.deviceType) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="standardName" label="巡检标准" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="删除" placement="top-start">
                  <i class="item-operation-icon el-icon-delete icon-blue"
                    @click="handleDelete(scope.row, scope.$index)"></i>
                </el-tooltip>
                <el-tooltip effect="dark" content="设置标准" placement="top-start">
                  <i class="item-operation-icon el-icon-s-tools icon-blue"
                    @click="handleSetStandard(scope.row, scope.$index)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="el-table__empty-block">
                <span class="el-table__empty-text">
                  <div class="ioc-crud__empty">
                    <div class="ioc-empty">
                      <div class="ioc-empty__image" style="height: 50px">
                        <img src="../img/empty.svg" alt="" />
                      </div>
                      <p class="ioc-empty__desc">暂无数据</p>
                    </div>
                  </div>
                </span>
              </div>
            </template>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 选择设备 -->
    <el-dialog :visible.sync="selectVisible" append-to-body width="1200px" @close="handleSelectCancel" title="选择设备">
      <div class="dialog-content" style="height: 500px">
        <el-form :inline="true">
          <el-form-item label="设备类型">
            <el-select v-model="deviceTypeForChoseDevice" placeholder="全部">
              <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearchDevice">查询</el-button>
            <el-button @click="handleResetDevice">重置</el-button>
          </el-form-item>
        </el-form>
        <el-transfer filterable :filter-method="filterMethod" :titles="['选择列表', '已选择']" filter-placeholder="请输入搜索内容"
          :props="transferProps" v-model="selectArr" :data="deviceData">
          <span slot-scope="{ option }">{{ option.label }}</span>
        </el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectConfirm">确 定</el-button>
        <el-button @click="handleSelectCancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 选择人员 -->
    <!-- <el-dialog title="人员列表" :visible.sync="chosePeopleVisible" append-to-body width="900px" @close="handleCancelPeople">
      <div class="dialog-content" style="height: 400px">
        <el-form :inline="true" :model="chosePeopleForm" label-width="50px" class="searchFormPeople">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input v-model="chosePeopleForm.name" style="width: 220px" placeholder="人员姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div class="searchArea">
                  <el-button type="primary" size="large" @click="handleSearchPeople">查询</el-button>
                  <el-button size="large" @click="handleResetPeople" class="reset">重置</el-button>
                </div>
              </el-form-item></el-col>
          </el-row>
        </el-form>
        <div style="flex: 1; height: 0; display: flex; flex-direction: column; overflow-x: hidden; overflow-y: auto;">
          <el-table :data="peopleTable" height="100%">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="nickName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="button">
                  <el-tooltip class="item" effect="dark" content="确认" placement="top" :open-delay="500">
                    <i class="item-operation-icon el-icon-check icon-blue" @click="handleSubmitPeople(scope.row)"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="el-table__empty-block">
                <span class="el-table__empty-text">
                  <div class="ioc-crud__empty">
                    <div class="ioc-empty">
                      <div class="ioc-empty__image" style="height: 50px">
                        <img src="../img/empty.svg" alt="" />
                      </div>
                      <p class="ioc-empty__desc">暂无数据</p>
                    </div>
                  </div>
                </span>
              </div>
            </template>
          </el-table>
        </div>

        <div class="meeting-footer">
          <el-pagination background @size-change="pageSizeChangePeople" @current-change="pageNoChangePeople"
            :current-page.sync="pageNoPeople" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size.sync="pageSizePeople"
            layout="total, sizes, prev, pager, next, jumper" :total="totalPeople"></el-pagination>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog title="人员列表" :visible.sync="chosePeopleVisible" append-to-body width="900px" @close="handleCancelPeople">
      <div class="dialog-content" style="height: 580px">
        <el-form :inline="true" :model="chosePeopleForm" label-width="50px" class="searchFormPeople">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input v-model="chosePeopleForm.name" style="width: 220px" placeholder="人员姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div class="searchArea">
                  <el-button type="primary" size="large" @click="handleSearchPeople">查询</el-button>
                  <el-button size="large" @click="handleResetPeople" class="reset">重置</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="flex: 1; height: 0; display: flex; flex-direction: column; overflow-x: hidden; overflow-y: auto;">
          <el-table ref="peopleRef" :data="peopleTable" height="100%" @selection-change="handleSelectionChange"
            :row-key="(row) => row.id">
            <el-table-column type="selection" :reverse-selection="true" width="55"></el-table-column>
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="nickName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button type="info" @click="selectCancel">取消</el-button>
          <el-button type="primary" @click="selectConfirm">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 批量选择标准 -->
    <el-dialog title="未选择标准设备类型" :visible.sync="setStandardMutilVisible" append-to-body width="600px"
      @close="cancelsetStandardMutil">
      <div class="dialog-content" style="height: 400px">
        <div style="flex: 1;height: 0;display: flex;flex-direction: column;overflow-x: hidden;overflow-y: auto;">
          <el-table height="100%" :data="mutilStandardData">
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <span>{{ dealdeviceType(scope.row.deviceType) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="standardName" label="巡检标准" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="button">
                  <el-tooltip class="item operating" effect="dark" content="确认" placement="top" :open-delay="500">
                    <i class="item-operation-icon el-icon-check icon-blue"
                      @click="setStandardByDeviceType(scope.row, scope.$index)">
                    </i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="el-table__empty-block">
                <span class="el-table__empty-text">
                  <div class="ioc-crud__empty">
                    <div class="ioc-empty">
                      <div class="ioc-empty__image" style="height: 50px">
                        <img src="../img/empty.svg" alt="" />
                      </div>
                      <p class="ioc-empty__desc">暂无数据</p>
                    </div>
                  </div>
                </span>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelsetStandardMutilForDevice">确 定</el-button>
        <el-button @click="cancelsetStandardMutil">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 选择标准 -->
    <el-dialog title="标准列表" :visible.sync="choseStandardVisible" append-to-body width="1100px" height="700px">
      <div class="dialog-content" style="height: 500px">
        <el-form :inline="true" :model="choseStandardForm" label-width="100px" class="searchFormPeople">
          <el-row>
            <el-col :span="9">
              <el-form-item label="名称">
                <el-input v-model="choseStandardForm.standardName" style="width: 220px" placeholder="标准名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <div class="searchArea">
                  <el-button type="primary" size="large" @click="handleSearchStandard">查询</el-button>
                  <el-button size="large" @click="handleResetStandard" class="reset">重置</el-button>
                </div>
              </el-form-item></el-col>
          </el-row>
        </el-form>
        <div style="
            flex: 1;
            height: 0;
            display: flex;
            flex-direction: column;
            overflow-x: hidden;
            overflow-y: auto;
          ">
          <el-table height="100%" :columns="tableColumnsPlan" :data="planTable" :page-size="pageSizeStandard"
            :page-no="pageNoStandard" :total="totalPlan" @pageNoChange="pageNoChangePlan"
            @pageSizeChange="pageSizeChangePlan">
            <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
            <el-table-column label="标准名称" align="center">
              <template slot-scope="scope">
                <span style="cursor: pointer; color: skyblue" @click="lookStandardDetail(scope.row)">{{
    scope.row.standardName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备类型" align="center">
              <template slot-scope="scope">
                <span>{{ dealdeviceType(scope.row.deviceType) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="standardRemarks" label="备注" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="button">
                  <el-tooltip class="item" effect="dark" content="确认" placement="top" :open-delay="500">
                    <i class="item-operation-icon el-icon-check icon-blue" @click="handleSubmitPlan(scope.row)"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="el-table__empty-block">
                <span class="el-table__empty-text">
                  <div class="ioc-crud__empty">
                    <div class="ioc-empty">
                      <div class="ioc-empty__image" style="height: 50px">
                        <img src="../img/empty.svg" alt="" />
                      </div>
                      <p class="ioc-empty__desc">暂无数据</p>
                    </div>
                  </div>
                </span>
              </div>
            </template>
          </el-table>
        </div>
        <div class="meeting-footer">
          <el-pagination background @size-change="pageSizeChangePlan" @current-change="pageNoChangePlan"
            :current-page.sync="pageNoStandard" :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size.sync="pageSizeStandard" layout="total, sizes, prev, pager, next, jumper"
            :total="totalPlan"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 查看标准详情 -->
    <el-dialog :visible.sync="standDetailVisible" append-to-body width="900px" title="标准详情">
      <div class="add-standard" style="height: 400px">
        <div class="add-standard__form">
          <el-form :model="standInfoForm" ref="form" label-position="right" label-width="100px" inline>
            <el-form-item label="标准名称：" prop="standardName">
              <span>{{ standInfoForm.standardName }}</span>
            </el-form-item>
            <el-form-item label="设备类型：" prop="deviceType">
              <span>{{ dealdeviceType(standInfoForm.deviceType) }}</span>
            </el-form-item>
            <el-form-item label="备注：">
              <span>{{ standInfoForm.standardRemarks }}</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="add-standard__table">
          <el-table height="100%" :columns="tableColumnDetail" :data="standItemList">
            <el-table-column label="项目名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.itemName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单位" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.itemUnit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="记录方式" align="center">
              <template slot-scope="scope">
                <span>{{ dealShowType(scope.row.showType) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="正常值/上限" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.showType !== '3' && scope.row.showType !== ''">{{ scope.row.upValue }}</span>
              </template>
            </el-table-column>
            <el-table-column label="异常值/下限" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.showType !== '3' && scope.row.showType !== ''">{{ scope.row.downValue }}</span>
              </template>
            </el-table-column>
            <el-table-column label="默认值" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.defaultValue }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleAddOrUpdate">确 定</el-button>
      <el-button @click="handleCancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "../api/index";
export default {
  name: "addPlanComponent",
  props: {
    title: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
      default: {},
    },
  },
  watch: {
    form: {
      handler(val) {
        const userName = []
        const userId = []
        if (val.users) {
          for (let i = 0; i < val.users.length; i++) {
            userName.push(val.users[i].username)
            userId.push(val.users[i].planUserUuid)
          }
        }
        if (val && val.planName) {
          this.planForm = {
            planName: val.planName || "",
            rate: val.planDateRate || "",
            dates:
              val.planDateRate == "0"
                ? [this.formatDate(val.startDate), this.formatDate(val.endDate)]
                : val.planDays,
            times: val.startTime || "",
            duration: val.duration || "",
            peopleName: userName.length > 0 ? userName.join(',') : '',
            peopleId: userId.length > 0 ? userId.join(',') : '',
            remark: val.remark || "",
          };
          this.tableData = val.devices.map((item) => {
            return {
              deviceName: item.deviceName,
              deviceType: item.deviceTypeCode,
              deviceCode: item.deviceCode,
              standardName: item.standardName,
              standardId: item.standardId,
            };
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      deviceTypeForChoseDevice: "",
      // 标准详情
      recordMethodList: [
        {
          label: "单选",
          value: "0",
        },
        {
          label: "多选",
          value: "1",
        },
        {
          label: "数值",
          value: "2",
        },
        {
          label: "文本",
          value: "3",
        },
      ],
      standDetailVisible: false,
      tableColumnDetail: [
        {
          label: "项目名称",
          prop: "itemName",
        },
        {
          label: "单位",
          prop: "itemUnit",
          width: 80,
        },
        {
          label: "记录方式",
          prop: "showType",
        },
        {
          label: "正常值/上限",
          prop: "upValue",
        },
        {
          label: "异常值/下限",
          prop: "downValue",
        },
        {
          label: "默认值",
          prop: "defaultValue",
        },
      ],
      // 批量设置标准
      setStandardType: "",
      setStandardMutilVisible: false,
      mutilStandardData: [],
      tableColumnsMutilStandard: [
        {
          label: "设备类型",
          prop: "deviceType",
        },
        {
          label: "巡检标准",
          prop: "standardName",
        },
        {
          label: "操作",
          prop: "operating",
        },
      ],
      // 批量设置标准
      tableColumnsPlan: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "标准名称",
          prop: "standardName",
        },
        {
          label: "设备类型",
          prop: "deviceType",
        },
        {
          label: "备注",
          prop: "standardRemarks",
        },
        {
          label: "操作",
          prop: "operate",
        },
      ],
      planTable: [],
      pageNoStandard: 1,
      pageSizeStandard: 20,
      totalPlan: 0,
      choseStandardVisible: false,
      choseStandardForm: {
        standardName: "",
        deviceType: "",
      },
      deviceTypeList: [
        {
          label: "摄像机",
          value: 18,
        },
      ],
      selectedDeviceRowIndex: null,
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      // 选择人员
      tableColumnsPeople: [
        {
          label: "序号",
          prop: "index",
          width: 80,
        },
        // {
        //   label: "姓名",
        //   prop: "userName",
        // },
        {
          label: "姓名",
          prop: "nickName",
        },
        {
          label: "联系电话",
          prop: "phone",
        },
        {
          label: "操作",
          prop: "operate",
        },
      ],
      peopleTable: [],
      chosePeopleVisible: false,
      chosePeopleForm: {
        name: "",
      },
      pageNoPeople: 1,
      pageSizePeople: 20,
      totalPeople: 0,

      transferProps: {
        key: "value",
        label: "label",
      },
      selectArr: [],
      deviceData: [
        {
          label: "Camera02",
          value: "20210306001289",
          type: "18",
          deviceCode: "20210306001289",
          deviceMarkList: null,
          deviceId: "20210306001289",
          createrTime: "2021-03-06 14:38:23",
          deviceNumber: "f86cca12-ed14-4ece-8167-246add97a8ea",
          deviceName: "Camera02",
          parentDeviceName: null,
          deviceDescription: null,
          parentDeviceDescription: null,
          factoryId: "10",
          factoryName: "华为",
          deviceType: "18",
          deviceMark: null,
          deviceTypeName: "摄像机",
          location: null,
          longitude: "118.2858467102",
          latitude: "35.0682970136",
          altitude: "3.000",
          area: "200000001",
          areaName: "鲁南制药集团",
          status: "1",
          statusName: "在线",
          cameraType: null,
          cameraTypeName: "",
          parentCodes: null,
          parentDeviceId: "200000005",
          parentDeviceIds: null,
          deviceVersion: null,
          parentDeviceVersion: null,
          systemId: "200000005",
          systemName: "华为公有云视频云IMES",
          ip: null,
          parentIp: null,
          port: null,
          mac: null,
          parentMac: null,
          thirdDeviceId: "f86cca12-ed14-4ece-8167-246add97a8ea",
          parentThirdDeviceId: null,
          thirdDeviceName: "Camera02",
          thirdDeviceDesc: null,
          cameraFeature: "2",
          cameraFeatureName: "车牌识别摄像机",
          isCameraGroup: "否",
          buildingId: "20210330000095",
          buildName: "A区-001车间-A30单体",
          floorId: "20210330000100",
          floorName: "顶层",
          isIndoor: "1",
          isIndoorName: "是",
          azimuth: "1",
          inclination: null,
          resolutionWide: null,
          resolutionHigh: null,
          subDeviceInfoList: null,
          deviceWorkGroupCode: "20221220000002",
          deviceWorkGroupName: "车辆布控摄像机组",
          unlockPassword: null,
          modifier: null,
          modifyTime: null,
          subDeviceMark: null,
          typeMark: null,
          parentTypeMark: null,
          loop: null,
          pageNum: null,
          pageSize: null,
          parentThirdDeviceDesc: null,
          isDeviceWorkGroup: null,
          secondaryCode: null,
          buildingCode: "20210330000100",
          buildingName: "顶层",
          fileCode: "group1/M00/05/66/CiiTg2RA_fGACAjuAAt_EmDNg8s444.png",
          abscissa: "503",
          ordinate: "265",
          width: "861",
          height: "500",
          plateNo: null,
          reviceTime: null,
          satelliteTime: null,
          mileage: null,
          positionFlag: null,
          createTime: null,
          slaveId: null,
          lastOnlineTime: null,
          modifyTimeStr: null,
          relationCameraType: null,
          cameraConfigFlag: null,
          parentBuildingCode: null,
          thirdDeviceIdAndNameStr: null,
          controlMode: null,
          codeType: null,
          controlCode: null,
          deviceExtendList: null,
          parentDeviceExtendList: null,
          deviceExtendMap: null,
          parentDeviceExtendMap: null,
          userName: null,
          password: null,
          trafficType: null,
        },
      ],
      standardList: [],
      selectVisible: false,
      multipleSelections: [],
      tableData: [],
      tableColumns: [
        {
          label: "巡检设备",
          prop: "deviceName",
        },
        {
          label: "设备类型",
          prop: "deviceType",
        },
        {
          label: "巡检标准",
          prop: "standardName",
        },
        {
          label: "操作",
          prop: "operating",
        },
      ],
      visible: false,
      planForm: {
        planName: "",
        rate: "",
        dates: [],
        times: "",
        duration: "",
        peopleName: "",
        peopleId: "",
        remark: "",
      },
      rules: {
        planName: [
          {
            required: true,
            message: "计划名称必填",
            trigger: "blur",
          },
        ],
        rate: [
          {
            required: true,
            message: "频率必选",
            trigger: "blur",
          },
        ],
        peopleName: [
          {
            required: true,
            message: "执行人员换必选",
            trigger: ["blur", "change"]
          },
        ],
        dates: [
          {
            required: true,
            message: "计划日期必填",
            trigger: "blur",
          },
        ],
        times: [
          {
            required: true,
            message: "开始时间必须填",
            trigger: "blur",
          },
        ],
        duration: [
          {
            required: true,
            message: "持续时间必填",
            trigger: "blur",
          },
        ],
      },
      rateList: [
        {
          label: "每天",
          value: "0",
        },
        {
          label: "自定义",
          value: "1",
        },
      ],
      standInfoForm: {},
      standItemList: [],
      selectedPerson: [],
    };
  },
  mounted() {
    this.visible = true;
    this.queryDeviceType();
    this.queryDeviceList();
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedPerson = val
    },
    selectConfirm() {
      let peopleName = []
      let peopleId = []
      for (let i = 0; i < this.selectedPerson.length; i++) {
        peopleName.push(this.selectedPerson[i].nickName)
        peopleId.push(this.selectedPerson[i].accountNumber)
      }
      this.chosePeopleForm.name = "";
      this.planForm.peopleName = peopleName.join(',');
      this.planForm.peopleId = peopleId.join(',');
      this.chosePeopleVisible = false
    },
    selectCancel() {
      this.planForm.peopleName = "";
      this.planForm.peopleId = "";
      this.chosePeopleForm.name = "";
      this.chosePeopleVisible = false
    },
    // 查看标准详情
    lookStandardDetail(row) {
      this.queryStandardInfo(row);
      this.queryStandardItemList(row);
      this.standDetailVisible = true;
    },
    /**
     * 获取巡检标准巡检项列表
     *
     */
    queryStandardItemList(row) {
      let url =
        api.standard.getStandardItemList + `?standardId=${row.standardId}`;
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.standItemList = res.data;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 获取巡检标准信息
     *
     */
    queryStandardInfo(row) {
      let url = api.standard.getStandardInfo + row.standardId;
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.standInfoForm = res.data;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查询所有设备
    handleSearchDevice() {
      this.queryDeviceList();
    },
    handleResetDevice() {
      this.deviceTypeForChoseDevice = "";
      this.queryDeviceList();
    },
    queryDeviceList() {
      this.$fetch(api.plan.getDeviceList, {
        page: 1,
        pageSize: 100000,
        deviceType: this.deviceTypeForChoseDevice,
      }).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj.list.map((item) => {
            return {
              label: item.deviceName,
              value: item.deviceId,
              type: item.deviceType,
              deviceCode: item.deviceId,
            };
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 批量设置标准
    setStandardMutil() {
      //批量弹出框
      let deviceTypeArr = [];
      this.tableData.forEach((item) => {
        if (
          !item.standardName &&
          !item.standardId &&
          deviceTypeArr.indexOf(item.deviceType) < 0
        ) {
          deviceTypeArr.push(item.deviceType);
          this.mutilStandardData.push({
            deviceType: item.deviceType,
            standardName: "",
            standardId: "",
          });
        }
      });
      console.log(this.tableData, deviceTypeArr);
      this.setStandardMutilVisible = true;
    },
    cancelsetStandardMutilForDevice() {
      //批量弹出框点击确认给选中设备设置标准
      console.log(this.tableData);
      console.log(this.mutilStandardData);
      if (this.mutilStandardData && this.mutilStandardData.length) {
        this.mutilStandardData.forEach((item) => {
          this.tableData.forEach((i) => {
            if (i.deviceType == item.deviceType) {
              i.standardName = item.standardName || "";
              i.standardId = item.standardId || "";
            }
          });
        });
      }
      this.mutilStandardData = [];
      this.setStandardMutilVisible = false;
    },
    cancelsetStandardMutil() {
      //批量弹出框关闭
      this.setStandardMutilVisible = false;
      this.mutilStandardData = [];
    },
    resetStandard() {
      this.tableData.forEach((item) => {
        item.standardName = "";
        item.standardId = "";
      });
    },
    setStandardByDeviceType(row, index) {
      this.setStandardType = "mutil";
      this.choseStandardForm.deviceType = row.deviceType;
      this.selectedDeviceRowIndex = index;
      this.queryInspectionList();
      this.choseStandardVisible = true;
    },
    // 设置选择设备的标准
    handleSetStandard(row, index) {
      this.setStandardType = "single";
      this.choseStandardForm.deviceType = row.deviceType;
      this.selectedDeviceRowIndex = index;
      this.queryInspectionList();
      this.choseStandardVisible = true;
    },
    // 把设备类型转换成设备类型名字
    dealdeviceType(value) {
      let result = "";
      this.deviceTypeList.forEach((item) => {
        if (item.value == value) {
          result = item.label;
        }
      });
      return result;
    },
    // 记录方式转换
    dealShowType(value) {
      let result = "";
      this.recordMethodList.forEach((item) => {
        if (item.value == value) {
          result = item.label;
        }
      });
      return result;
    },
    // 获取设备类型getDeviceType
    queryDeviceType() {
      this.$fetch(api.standard.getDeviceType).then((res) => {
        this.deviceTypeList = res.returnObj.map((item) => {
          return {
            label: item.deviceTypeName || "",
            value: item.deviceTypeId || "",
          };
        });
      });
    },
    /**
     * 获取巡检列表
     */
    queryInspectionList() {
      let url =
        api.standard.getInspectionList +
        `?pageNo=${this.pageNoStandard}&pageSize=${this.pageSizeStandard}`;

      if (this.choseStandardForm.standardName) {
        url += `&standardName=${this.choseStandardForm.standardName}`;
      }
      if (this.choseStandardForm.deviceType) {
        url += `&deviceType=${this.choseStandardForm.deviceType}`;
      }
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.planTable = res.data.list;
          this.totalPlan = res.data.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 选择人员
    /**
     * 查询用户列表
     */
    // handleSearchUserList() {
    //   this.$fetch(api.plan.getUsersList, {
    //     name: this.chosePeopleForm.name,
    //     pageNum: this.pageNoPeople,
    //     pageSize: this.pageSizePeople,
    //     personnelType: 1,
    //   }).then((res) => {
    //     const newList = res.returnObj.list.map((item, index) => {
    //       return {
    //         ...item,
    //         userId: item.personnelCode,
    //         userName: item.name,
    //       };
    //     });

    //     this.peopleTable = newList;
    //     this.totalPeople = res.returnObj.total;
    //   });
    // },
    handleSearchUserList() {
      this.$fetch(api.plan.getSysUsersList, {
        nickName: this.chosePeopleForm.name,
        pageNo: this.pageNoPeople,
        pageSize: 10000
      }).then((res) => {
        this.peopleTable = res.returnObj.list;
        this.totalPeople = res.returnObj.total;
        const selectedPeopleId = this.planForm.peopleId.split(',')
        const selectRow = []
        const unSelectRow = []
        if (selectedPeopleId.length == 0) {
          this.$nextTick(() => {
            this.$refs.peopleRef.clearSelection()
          })
        } else {
          this.peopleTable.forEach(item => {
            if (selectedPeopleId.includes(item.accountNumber)) {
              selectRow.push(item)
              this.$nextTick(() => {
                this.$refs.peopleRef.toggleRowSelection(item, true);
              })
            } else {
              unSelectRow.push(item)
            }
          })
          this.peopleTable = selectRow.concat(unSelectRow)
        }
      });
    },
    chosePeople() {
      this.chosePeopleVisible = true;
      this.handleSearchUserList();
    },
    handleSearchPeople() {
      this.handleSearchUserList();
    },
    handleResetPeople() {
      this.chosePeopleForm.name = "";
      this.handleSearchPeople();
    },
    pageSizeChangePeople(pageSize) {
      this.pageNoPeople = 1;
      this.pageSizePeople = pageSize;
      this.handleSearchPeople();
    },
    pageNoChangePeople(pageNo) {
      this.pageNoPeople = pageNo;
      this.handleSearchPeople();
    },
    pageSizeChangePlan(pageSize) {
      this.pageNoStandard = 1;
      this.pageSizeStandard = pageSize;
      this.queryInspectionList();
    },
    pageNoChangePlan(pageNo) {
      this.pageNoStandard = pageNo;
      this.queryInspectionList();
    },
    handleSubmitPeople(row) {
      this.chosePeopleVisible = false;
      this.planForm.peopleName = row.nickName;
      this.planForm.peopleId = row.accountNumber;
    },
    handleSubmitPlan(row) {
      if (this.setStandardType == "single") {
        this.tableData[this.selectedDeviceRowIndex].standardName =
          row.standardName;
        this.tableData[this.selectedDeviceRowIndex].standardId = row.standardId;
        this.choseStandardVisible = false;
      } else {
        this.mutilStandardData[this.selectedDeviceRowIndex].standardName =
          row.standardName;
        this.mutilStandardData[this.selectedDeviceRowIndex].standardId =
          row.standardId;
        this.choseStandardVisible = false;
      }
    },
    handleCancelPeople() {
      this.chosePeopleForm.name = "";
      this.chosePeopleVisible = false;
    },
    handleCancelPlan() {
      this.choseStandardForm.standardName = "";
      this.choseStandardForm.deviceType = "";
      this.choseStandardVisible = false;
    },
    handleSearchStandard() {
      this.queryInspectionList();
    },
    handleResetStandard() {
      this.choseStandardForm.standardName = "";
      this.choseStandardForm.deviceType = "";
      this.queryInspectionList();
    },
    //选择人员

    // 确认设备
    handleSelectConfirm() {
      const arr = this.selectArr.map((key) => {
        return {
          deviceName:
            this.deviceData[
              this.deviceData.findIndex((item) => item.value === key)
            ].label,
          deviceType:
            this.deviceData[
              this.deviceData.findIndex((item) => item.value === key)
            ].type,
          deviceCode:
            this.deviceData[
              this.deviceData.findIndex((item) => item.value === key)
            ].deviceCode,
          standardName: "",
        };
      });
      this.tableData = this.tableData.concat(arr);
      console.info("this.tableData", this.tableData, arr);
      this.handleSelectCancel();
    },
    handleSelectCancel() {
      this.selectArr = [];
      this.selectVisible = false;
    },
    handleAddDevice() {
      if (
        !this.deviceTypeForChoseDevice &&
        this.deviceTypeList &&
        this.deviceTypeList.length
      ) {
        this.deviceTypeForChoseDevice = this.deviceTypeList[0].value;
      }
      this.selectVisible = true;
    },
    handleDelete(row, index) {
      this.tableData.splice(index, 1);
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleAddOrUpdate() {
      this.$refs["planForm"].validate((valid) => {
        if (valid) {
          if (!this.tableData || !this.tableData.length) {
            this.$message.warning("请选择设备");
            return;
          }
          let result = this.tableData.every((item) => {
            return item.standardName && item.standardId;
          });
          if (!result) {
            this.$message.warning("请为设备设置标准");
            return;
          }
          let param = {
            planType: "1",
            planName: this.planForm.planName,
            planDateRate: this.planForm.rate,
            startDate:
              this.planForm.rate == "0"
                ? this.planForm.dates[0] + " " + "00:00:00"
                : "",
            endDate:
              this.planForm.rate == "0"
                ? this.planForm.dates[1] + " " + "00:00:00"
                : "",
            startTime: this.planForm.times,
            remark: this.planForm.remark,
            duration: this.planForm.duration,
            planDays:
              this.planForm.rate == "0" ? "" : Array.isArray(this.planForm.dates) ? this.planForm.dates.join(",") : this.planForm.dates,
          };

          // console.log("新增参数", param);
          if (this.title == "新增计划") {
            this.$fetch(api.plan.addPlan, param).then((res) => {
              if (res.success) {
                this.dealPlanItemList(res.data.planId, this.tableData);
                this.dealPlanPeopleList(
                  res.data.planId,
                  this.planForm.peopleName,
                  this.planForm.peopleId
                );
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.msgContent);
              }
            });
          } else {
            param.planId = this.form.planId;
            this.$fetch(api.plan.editPlan, param).then((res) => {
              if (res.success) {
                this.dealPlanItemList(this.form.planId, this.tableData);
                this.dealPlanPeopleList(
                  this.form.planId,
                  this.planForm.peopleName,
                  this.planForm.peopleId
                );
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.msgContent);
              }
            });
          }
        }
      });
    },
    // 批量保存巡检项
    dealPlanItemList(id, list) {
      let resultList = list.map((item) => {
        return {
          planId: id,
          deviceCode: item.deviceCode,
          standardId: item.standardId,
          planDetailRemarks: "",
        };
      });
      console.log("巡检项", resultList);
      let askParam = {
        list: resultList,
      };
      this.$fetch(api.plan.savePlanItemList, askParam).then((res) => {
        if (res.success) {
          // this.$message.success(res.msgContent)
          this.$emit("handleConfirm");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 批量保存计划人员
    dealPlanPeopleList(id, userName, userId) {
      let resultList = []
      let userIdArr = userId.split(',')
      let userNameArr = userName.split(',')
      for (let i = 0; i < userIdArr.length; i++) {
        resultList.push({
          planId: id,
          username: userNameArr[i],
          planUserUuid: userIdArr[i]
        })
      }
      let askParam = {
        list: resultList,
      };
      this.$fetch(api.plan.savePeopleList, askParam).then((res) => {
        if (res.success) {
          // this.$message.success(res.msgContent)
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    changeSelection(val) {
      this.multipleSelections = val;
    },
    handleBatchDelete() {
      if (this.multipleSelections.length === 0) {
        this.$message.info("请先选择！");
        return;
      }
      const arr = [];
      this.tableData.forEach((item) => {
        if (this.multipleSelections.join(",").indexOf(item.deviceCode) === -1) {
          arr.push(item);
        }
      });
      this.tableData = JSON.parse(JSON.stringify(arr));
    },
    // 日期格式化
    formatDate(param) {
      var date = null;
      date = new Date(param);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var strHours = date.getHours();
      var strMinutes = date.getMinutes();
      var strSeconds = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (strHours >= 0 && strHours <= 9) {
        strHours = "0" + strHours;
      }
      if (strMinutes >= 0 && strMinutes <= 9) {
        strMinutes = "0" + strMinutes;
      }
      if (strSeconds >= 0 && strSeconds <= 9) {
        strSeconds = "0" + strSeconds;
      }
      var currentdate = year + "-" + month + "-" + strDate;
      return currentdate;
    },
  },
};
</script>

<style lang='scss'>
@import "~@src/common/assets/style/mixin";

.add-standard {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__form {
    display: flex;
    flex-wrap: wrap;
  }

  &__opt {
    margin-bottom: 15px;
  }

  &__table {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .operating {
    display: flex;
    align-items: center;

    .options_icon {
      cursor: pointer;
      margin-right: 10px;
    }

    .iconDelete {
      font-size: 12px;
    }
  }
}

.item-operation-icon {
  font-size: 14px;
  cursor: pointer;
  margin: 0 8px;
}

.add-plan {
  display: flex;
  flex-direction: column;
  height: 600px;

  &__form {
    display: flex;
    flex-wrap: wrap;
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0;

    .info-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      &__opt {
        margin-bottom: 15px;
        display: flex;

        .soc_button+.soc_button {
          margin-left: 10px;
        }
      }
    }
  }

  .operating {
    display: flex;
    align-items: center;

    .options_icon {
      cursor: pointer;
      margin-right: 10px;

      // &:hover {
      //   @include set_primary_theme(color);
      // }
    }

    .iconDelete {
      font-size: 12px;
    }
  }
}

.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.searchFormPeople {
  .searchArea {
    display: flex;
    flex-direction: row;

    .reset {
      margin-left: 16px;
    }
  }
}

.el-transfer-panel__body {
  height: 390px;
}

.el-transfer-panel .el-transfer-panel__header {
  // border-bottom: 1px solid #3e4866;
  // background: #202945;
  @include set_theme_color(background-color, blur-color);
}

.el-transfer-panel {
  border: 1px solid #3e4866;
  border-radius: unset;
  // width: 243px;
  width: 40%;
  // margin-left: 10px;
  // background: #202945;
  @include set_theme_color(background-color, top-menu-bg-color);
}

.el-transfer__button.is-disabled {
  background: #3e4866;
  // width: 80px;
}

.el-transfer__button.is-disabled:hover {
  background: #3e4866;
}
</style>
<style scoped>
*>>>.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  color: #ccc;
}

*>>>.el-transfer-panel__list {
  height: 80%;
}

.meeting-footer {
  /* background: #181f2e; */
  display: flex;
  justify-content: center;
  padding: 15px 0;
}
</style>
